import loanFormModel from '../../components/loan_application/form_models/loanFormModel';
import { defaultBorrowerLegalName } from '../../components/loan_application/form_models/constants';
import { genericRequiredFieldError } from '../../constants';
import { ValidationSchema } from '../interfaces';
import { Validation } from '../Validation';

const {
  formField: {
    systemPowerSingleOrMultipleUsers,
    systemPowerTaxEquityPartnering,
    systemPowerCommunityOrPPALease,
  },
} = loanFormModel;

export class PowerTaxEquityPartneringValidation implements ValidationSchema {
  public name: string = systemPowerTaxEquityPartnering.name;
  public label: string = systemPowerTaxEquityPartnering.getLabel(
    defaultBorrowerLegalName
  );
  public dependsOn: string[] = [
    systemPowerSingleOrMultipleUsers.name,
    systemPowerCommunityOrPPALease.name,
  ];
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;

  when(singleOrMultipleUsers: string, communityOrPPALease: string, schema) {
    if (
      singleOrMultipleUsers === 'Single User' ||
      (singleOrMultipleUsers === 'Multiple Users' &&
        communityOrPPALease === 'PPA/Lease Agreement')
    ) {
      return schema.required(genericRequiredFieldError);
    }
    return schema;
  }
}
export default new Validation(new PowerTaxEquityPartneringValidation());
